export default "__VITE_ASSET__baf89ca3__"